module.exports = __webpack_public_path__ + "img/xiaozi_jiaoliu.96ea4264.svg";